export var FRACTION_CONFIG = {
    'fraction-1': {
        id: 'fraction-1',
        numerator: 1,
        denominator: 1,
        rectangle: { width: 660, height: 55 },
        circle: { start: 0, sweep: 360 },
        button: { width: 120, height: 50, circleSize: 120 }
    },
    'fraction-1-2': {
        id: 'fraction-1-2',
        numerator: 1,
        denominator: 2,
        rectangle: { width: 330, height: 55 },
        circle: { start: 0, sweep: 180 },
        button: { width: 110, height: 50, circleSize: 120 }
    },
    'fraction-1-3': {
        id: 'fraction-1-3',
        numerator: 1,
        denominator: 3,
        rectangle: { width: 220, height: 55 },
        circle: { start: 30, sweep: 120 },
        button: { width: 99, height: 50, circleSize: 104 }
    },
    'fraction-1-4': {
        id: 'fraction-1-4',
        numerator: 1,
        denominator: 4,
        rectangle: { width: 165, height: 55 },
        circle: { start: 45, sweep: 90 },
        button: { width: 89, height: 50, circleSize: 85 }
    },
    'fraction-1-5': {
        id: 'fraction-1-5',
        numerator: 1,
        denominator: 5,
        rectangle: { width: 132, height: 55 },
        circle: { start: 54, sweep: 72 },
        button: { width: 79, height: 50, circleSize: 71 }
    },
    'fraction-1-6': {
        id: 'fraction-1-6',
        numerator: 1,
        denominator: 6,
        rectangle: { width: 110, height: 55 },
        circle: { start: 60, sweep: 60 },
        button: { width: 68, height: 50, circleSize: 60 }
    },
    'fraction-1-8': {
        id: 'fraction-1-8',
        numerator: 1,
        denominator: 8,
        rectangle: { width: 82.5, height: 55 },
        circle: { start: 67.5, sweep: 45 },
        button: { width: 58, height: 50, circleSize: 46 }
    },
    'fraction-1-10': {
        id: 'fraction-1-10',
        numerator: 1,
        denominator: 10,
        rectangle: { width: 66, height: 55 },
        circle: { start: 72, sweep: 36 },
        button: { width: 48, height: 50, circleSize: 37 }
    },
    'fraction-1-12': {
        id: 'fraction-1-12',
        numerator: 1,
        denominator: 12,
        rectangle: { width: 55, height: 55 },
        circle: { start: 75, sweep: 30 },
        button: { width: 37, height: 50, circleSize: 31 }
    }
};
export var getFractionConfig = function (id) { return FRACTION_CONFIG[id]; };
